import LoaderImg from '../../assets/loading.png';

const Loader = ({ height, margin }) => {
    return (
        <div className={`col-span-2 md:col-span-3 lg:col-span-4 flex items-center justify-center ${height ? height : 'h-[85vh]'} ${margin ? margin : ''}`}>
            <img src={LoaderImg} alt='loading' className='w-8 h-8 animate-spin' />
        </div>
    )
}

export default Loader;